import * as types from "./mutation-types";
import Vue from "vue";
import moment from "moment";

const actions = {
  async createAdminMemberNotice(_, payload) {
    const { message, duration, begins, expires } = payload;

    let response = null;

    // Notices will default to Primary color
    try {
      response = await Vue.axios.post("notices", {
        message,
        duration,
        allMembers: 1,
        type: "admin",
        begins,
        expires
      });
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not create notice, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: errorMessage
      };
    }

    return response;
  },
  async createOrganizationNotice({ commit }, payload) {
    const { message, organizationId, programId } = payload;

    let response = null;
    let params = {
      message,
      organizationId,
      programId,
      type: "org"
    };
    // Notices will default to Primary color
    try {
      response = await Vue.axios.post("notice/organization", params);
      commit("members/SET_MEMBER_ORGANIZATION_NOTICE", response.data.data, {
        root: true
      });
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not create notice, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: errorMessage
      };
    }

    return response;
  },

  async updateAdminMemberNotice(_, payload) {
    const { noticeId, message, expires, begins } = payload;

    let response = null;

    try {
      response = await Vue.axios.post(`notices/${noticeId}`, {
        message,
        expires,
        type: "admin",
        begins
      });
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not update notice, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: errorMessage
      };
    }

    return response;
  },

  async updateOrganizationNotice({ commit }, payload) {
    const { noticeId, message, programId } = payload;

    let response = null;

    try {
      response = await Vue.axios.post(`notice/organization/${noticeId}`, {
        message,
        programId
      });
      commit("members/SET_MEMBER_ORGANIZATION_NOTICE", response.data.data, {
        root: true
      });
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not update notice, please contact wellness@be-engaged.co";
      }
      response = {
        error: true,
        message: errorMessage
      };
    }
    return response;
  },

  async removeAdminMemberNotice(_, payload) {
    const { noticeId } = payload;

    let response = null;

    try {
      response = await Vue.axios.delete(`notices/${noticeId}`);
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not delete notice, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: errorMessage
      };
    }

    return response;
  },

  async removeOrganizationNotice({ commit }, payload) {
    const { noticeId } = payload;

    let response = null;

    try {
      response = await Vue.axios.delete(`notices/${noticeId}`);
      commit(
        "members/SET_MEMBER_ORGANIZATION_NOTICE",
        {},
        {
          root: true
        }
      );
    } catch (e) {
      const error = e.response.data.error;
      let errorMessage = null;

      if (error.fields && error.fields.message) {
        errorMessage = error.fields.message[0];
      } else {
        errorMessage =
          "Could not delete notice, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: errorMessage
      };
    }

    return response;
  },

  fetchProgramNotices({ commit }) {
    return Vue.axios.get("notices").then(response => {
      if (response.data.data) {
        commit(types.SET_PROGRAM_NOTICES, response.data.data);
      }
      commit(types.SET_LOADED_STATUS, {
        key: "programNoticesLoaded",
        value: true
      });
    });
  },

  fetchOrganizationNotice({ commit }, payload) {
    const { organizationId, programId } = payload;
    let params = {
      organizationId,
      programId
    };
    return Vue.axios.get(`notices/organization`, { params }).then(response => {
      if (response.data.data) {
        commit(types.SET_ORGANIZATION_NOTICE, response.data.data);
      }
      commit(types.SET_LOADED_STATUS, {
        key: "organizationNoticeLoaded",
        value: true
      });
    });
  },

  removeProgramAndMemberNotice({ commit, rootState }, noticeId) {
    let programNoticesCopy = JSON.parse(
      JSON.stringify(rootState.notices.programNotices)
    );
    let memberNoticesCopy = JSON.parse(
      JSON.stringify(rootState.members.memberNotice)
    );
    const removedProgramNoticeIndex = programNoticesCopy.findIndex(
      notice => notice.id === noticeId
    );
    const removedMemberNoticeIndex = memberNoticesCopy.findIndex(
      notice => notice.id === noticeId
    );
    if (removedProgramNoticeIndex > -1) {
      programNoticesCopy.splice(removedProgramNoticeIndex, 1);
    }
    if (removedMemberNoticeIndex > -1) {
      memberNoticesCopy.splice(removedMemberNoticeIndex, 1);
    }

    commit(types.SET_PROGRAM_NOTICES, programNoticesCopy);
    commit("members/SET_MEMBER_NOTICE", memberNoticesCopy, { root: true });
  },

  setProgramAndMemberNotices({ commit, rootState }, notice) {
    let programNoticesCopy = JSON.parse(
      JSON.stringify(rootState.notices.programNotices)
    );
    let memberNoticesCopy = JSON.parse(
      JSON.stringify(rootState.members.memberNotice)
    );

    if (moment().diff(moment(notice.begins), "days") >= 0) {
      memberNoticesCopy.unshift(notice);
      programNoticesCopy.unshift(notice);
    }

    commit(types.SET_PROGRAM_NOTICES, programNoticesCopy);
    commit("members/SET_MEMBER_NOTICE", memberNoticesCopy, { root: true });
  },

  setUpdatedProgramAndMemberNotices({ commit, rootState }, notice) {
    let programNoticesCopy = JSON.parse(
      JSON.stringify(rootState.notices.programNotices)
    );
    let memberNoticesCopy = JSON.parse(
      JSON.stringify(rootState.members.memberNotice)
    );

    const updatedProgramNoticeIndex = programNoticesCopy.findIndex(
      notice => notice.id === notice.id
    );
    const updatedMemberNoticeIndex = memberNoticesCopy.findIndex(
      notice => notice.id === notice.id
    );
    // if active edit else remove it from active notices
    if (moment().diff(moment(notice.begins), "days") >= 0) {
      programNoticesCopy[updatedProgramNoticeIndex] = notice;
      memberNoticesCopy[updatedMemberNoticeIndex] = notice;
    } else {
      programNoticesCopy.splice(updatedProgramNoticeIndex, 1);
      memberNoticesCopy.splice(updatedMemberNoticeIndex, 1);
    }

    commit(types.SET_PROGRAM_NOTICES, programNoticesCopy);
    commit("members/SET_MEMBER_NOTICE", memberNoticesCopy, { root: true });
  },

  async dismissNotice({ commit, rootState }, noticeId) {
    let memberNoticesCopy = JSON.parse(
      JSON.stringify(rootState.members.memberNotice)
    );
    const removedNoticeIndex = memberNoticesCopy.findIndex(
      notice => notice.id === noticeId
    );
    if (removedNoticeIndex > -1) {
      memberNoticesCopy.splice(removedNoticeIndex, 1);
    }

    await Vue.axios.post(`notices/${noticeId}/dismiss`);

    commit("members/SET_MEMBER_NOTICE", memberNoticesCopy, { root: true });
  },

  async dismissOrganizationNotice({ commit }, noticeId) {
    await Vue.axios.post(`notices/${noticeId}/dismiss`);
    commit("members/SET_MEMBER_ORGANIZATION_NOTICE", {}, { root: true });
  },

  setOrganizationNotice({ commit }, notice) {
    commit(types.SET_ORGANIZATION_NOTICE, notice);
  }
};

export default actions;
